import React from 'react';
import { PureGetHelpPanel } from './index';
import { StaticImage } from 'gatsby-plugin-image';
import * as PropTypes from 'prop-types';
import { useFormHandlers } from '../FinanceCalculator/useFormHandlers';

const GetHelpPanel = ({ offer, ...props }) => {
  const { addEnquiry, addTestDriveEnquiry, addCallBackEnquiry } = useFormHandlers();

  return (
    <PureGetHelpPanel
      onSubmitTestDriveForm={addTestDriveEnquiry}
      onSubmitCallbackForm={addCallBackEnquiry}
      onSubmitEnquiryForm={addEnquiry}

      {...props}

      allowTestDrive={offer && true}
      helpImageElement={
        // null
        <StaticImage

          src={'./images/getHelp.jpg'}
          layout="constrained"
          alt={'Get Help'}
        />
      }
      testDriveImageElement={
        // null
        <StaticImage
          src={'./images/testDrive.jpg'}
          layout="constrained"
          alt={'Book a test drive'}
        />
      }
    />
  );
};

GetHelpPanel.propTypes = {
  offer: PropTypes.shape({})
};

export default GetHelpPanel;
export { GetHelpPanel };